import { InputModel } from '../../../../utils/types'
import { Item, ObjectGeneric } from '../../../../utils/types/generals'

export type SubmitPermissions = () => Promise<boolean | {}>

export enum TableType {
  QUESTIONNAIRE = 'questionnaire',
  FOLIO = 'folio'
}

export enum GroupType {
  WITH_GROUP = 'WITH_GROUP',
  WITHOUT_GROUP = 'WITHOUT_GROUP'
}


export type PermissionsData = { thereAreChanged: boolean; checksUser: ObjectGeneric; users: Record<string, boolean>; usersWithoutPersmissions: string[]; usersOld: Record<string, boolean>; table: any[] }
export interface Props {
  next: () => void
  back: (payload: PermissionsData) => void
  id?: number
  itemsManage: Record<string, Item[]>
  loading: boolean
  input: { [x: string]: InputModel }
  data?: PermissionsData
  submit: {
    submit: (payload: PermissionsData) => void
    title: string
    disabled: boolean
  }
}
